// extracted by mini-css-extract-plugin
export var alignBaseline = "_a-9";
export var alignCenter = "_a-5";
export var alignFlexEnd = "_a-7";
export var alignFlexStart = "_a-6";
export var alignSelfBaseline = "_a-e";
export var alignSelfCenter = "_a-a";
export var alignSelfFlexEnd = "_a-c";
export var alignSelfFlexStart = "_a-b";
export var alignSelfStretch = "_a-d";
export var alignStretch = "_a-8";
export var column = "_a-2";
export var columnReverse = "_a-4";
export var flex = "_a-0";
export var justifyCenter = "_a-f";
export var justifyFlexEnd = "_a-h";
export var justifyFlexStart = "_a-g";
export var justifySpaceAround = "_a-j";
export var justifySpaceBetween = "_a-i";
export var justifySpaceEvenly = "_a-k";
export var row = "_a-1";
export var rowReverse = "_a-3";
export var wrapNowrap = "_a-m";
export var wrapWrap = "_a-l";
export var wrapWrapReverse = "_a-n";